<nb-card>
<div style="padding: 20px; text-align: center">
  <p>
    <app-secured-image src="/dam/get-image-dynamic/{{id}}/540"></app-secured-image>
  </p>
    <button nbButton [hero]="true" (click)="dismiss(true)" i18n="@@Ok">OK</button>
</div>
</nb-card>
